import { pagination } from "../../components/Pagination/Pagination";
import "./search-page.scss";
import searchResultTemplate from "./SearchResult.hbs";
import axios from "axios";

(function () {
    if (document.querySelectorAll(".js-search").length > 0) {

        const searchPage = {
            store: {
                charArray: [16, 17, 18, 20, 27, 37, 38, 39, 40],
                isLoading: false,
                data: null,
                documentBody: document.getElementsByTagName("body")[0],
            },
            init: function () {
                pagination.init();
                searchPage.toggleSearchPanel();
                searchPage.onUserSearch();
            },
            toggleSearchPanel: () => {
                const openSearchButtons = document.getElementsByClassName("js-search");
                const closeSearchButtons = document.getElementsByClassName("js-search-close");
                const documentBody = document.getElementsByTagName("body")[0];

                Array.from(openSearchButtons).forEach(btn => {
                    btn.addEventListener("click", () => {
                        const container = btn.closest(".js-search-wrapper");
                        const searchPanel = container.getElementsByClassName("js-search-panel")[0];
                        const searchField = container.getElementsByClassName("js-search-input")[0];

                        documentBody.classList.add("search--expanded");

                        searchPanel.classList.add("search__panel--visible");

                        searchField.focus();
                    });
                });

                Array.from(closeSearchButtons).forEach(btn => {
                    btn.addEventListener("click", () => {
                        const container = btn.closest(".js-search-wrapper");
                        const searchPanel = container.getElementsByClassName("js-search-panel")[0];
                        const searchField = container.getElementsByClassName("js-search-input")[0];
                        const resultsList = container.getElementsByClassName("js-results-list")[0];
                        
                        searchPanel.classList.remove("search__panel--visible");

                        documentBody.classList.remove("search--expanded");
                        searchPage.store.documentBody.classList.remove(
                            "search__results--show"
                        );

                        resultsList.innerHTML = "";
                        searchField.value = "";
                    });
                });
            },
            onUserSearch: () => {
                const searchField = document.getElementsByClassName("js-search-input");
                const searchPageUrl = document.getElementById("search-page-url");
                Array.from(searchField).forEach(input => {
                    input.addEventListener("keyup", (e) => {
                        if (e.keyCode === 13) {
                            if (searchPageUrl !== "") {
                                window.location.href =
                                    searchPageUrl.value + "?q=" + input.value;
                            }
                        } else {
                            searchPage.store.documentBody.classList.remove(
                                "search__results--show"
                            );

                            const container = input.closest(".js-search-wrapper");
    
                            if (!searchPage.store.charArray.includes(e.keyCode)) {
                                if (input.value.length > 2) {
                                    searchPage.store.documentBody.classList.add(
                                        "search--searching"
                                    );
                                    doSearch(input.value, container);
                                }
                            }
                        }
                    });
                });

                let delayTimer;

                function doSearch(text, container) {
                    clearTimeout(delayTimer);

                    delayTimer = setTimeout(function () {
                        searchPage.performSearch(text, container);
                    }, 1000);
                }
            },
            performSearch: (searchTerm, container) => {
                const CancelToken = axios.CancelToken;
                let cancel;

                if (cancel !== undefined) {
                    cancel();
                }

                searchPage.store.isLoading = true;
                searchPage.renderView(null, container);
                axios
                    .get(
                        `/api/search/autocomplete?q=${searchTerm}&lang=${document.documentElement.lang}`,
                        {
                            cancelToken: new CancelToken(function executor(c) {
                                cancel = c;
                            }),
                        }
                    )
                    .then(function (response) {
                        searchPage.store.data = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                        searchPage.store.documentBody.classList.remove(
                            "search--searching"
                        );
                    })
                    .finally(function () {
                        searchPage.store.isLoading = false;
                        searchPage.renderView(searchPage.store.data, container);
                    });
            },
            renderView: (data, container) => {
                const target = container.getElementsByClassName("js-results-list")[0];

                if (target !== null) {
                    target.innerHTML = searchResultTemplate(data);

                    setTimeout(function () {
                        searchPage.store.documentBody.classList.add(
                            "search__results--show"
                        );
                        searchPage.store.documentBody.classList.remove(
                            "search--searching"
                        );
                    }, 100);
                }
            }
        };

        searchPage.init();
    }
})();
